import { render, staticRenderFns } from "./ExportationFrameComments.vue?vue&type=template&id=ec99e176&scoped=true&"
import script from "./ExportationFrameComments.vue?vue&type=script&lang=ts&"
export * from "./ExportationFrameComments.vue?vue&type=script&lang=ts&"
import style0 from "./ExportationFrameComments.vue?vue&type=style&index=0&id=ec99e176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec99e176",
  null
  
)

export default component.exports